<style lang="scss">
</style>

<script>
  import TextToggle from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/TextToggle.svelte";
  import { integrationStore } from "../../../stores";

  const handleToggle = (newValue) => {
    $integrationStore.setValue("enabled", newValue, "dataRefresh");
  };
</script>

<TextToggle
  checked={$integrationStore.getValue("enabled", "dataRefresh")}
  onToggle={handleToggle}
  label="Enable Data Refresh"
/>
